import React, { useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

const BiographyField = ({
  biographyData,
  setBiographyData,
  setShowIcons,
}: any) => {
  useEffect(() => {
    setShowIcons((prevState: any) => ({
      ...prevState,
      biography: !!biographyData.biography,
    }));
  }, [biographyData, setShowIcons]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setBiographyData((prevData: any) => ({
      ...prevData,
      biography: value,
    }));
  };

  return (
    <Grid
      display={'flex'}
      gap={5}
      flexDirection={'column'}
      p={{ xs: 2, md: 5 }}
      mt={{ xs: 3, md: 0 }}>
      <Grid
        item
        xs={12}
        sm={6}
        display={'flex'}
        flexDirection={'column'}
        gap={1}>
        <label
          htmlFor='biography'
          style={{
            fontWeight: 400,
            fontSize: '17px',
            color: '#000000',
          }}>
          Biography
        </label>
        <Grid display={'flex'} gap={2} alignItems={'center'} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name='biography'
              type='biography'
              multiline
              rows={10}
              sx={{ width: '100%', maxWidth: '654px' }}
              value={biographyData?.biography}
              onChange={handleChange}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BiographyField;
